const Events = {
  onCtaPress: 'onCtaPress',
  onRecommendationPress: 'onRecommendation',
  onCtaPanelReload: 'onCtaPanelReload'
};

export default Events;
